import axios from "axios";
import { useLocalAuth } from "@/components/auth/ClerkAuthProvider";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const REFRESH_EVENT = "odonto:refresh";

export const notifyRefresh = () => window.dispatchEvent(new Event(REFRESH_EVENT));

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Verifique os campos preenchidos";
  return "Não foi possível concluir. Tente novamente.";
};

export function useApi() {
  const { token } = useLocalAuth();
  const tokenRef = useRef(token);
  tokenRef.current = token;
  return useMemo(() => {
    const c = axios.create({ baseURL: API });
    c.interceptors.request.use(async (cfg) => {
      const t = tokenRef.current;
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return c;
  }, []);
}

export function useResource(path) {
  const api = useApi();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!path) return;
    try {
      const r = await api.get(path);
      setData(r.data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [api, path]);
  useEffect(() => { reload(); }, [reload]);
  useEffect(() => {
    window.addEventListener(REFRESH_EVENT, reload);
    return () => { window.removeEventListener(REFRESH_EVENT, reload); };
  }, [reload]);
  return { data, loading, reload, setData };
}
